<template>
    <div class="images">
        <div v-for="activity in dataList" :key="activity.modeID" >
            <div class="item-content" @click="showHouse(activity)">
                <img v-if="activity.imgUrl != null"  :src="activity.imgUrl">
                <img v-else src="~@/image/2.jpg">
                <div class="item-options">
                    <div>
                        <div class="address">
                            <div>{{ activity.wechatName }}</div> <div>{{ activity.activityName }}</div>
                            <div v-if="activity.startTime !=null">活动时间：{{activity.startTime}} - {{activity.endTime}}</div>
                            <div v-else>未进行消息推送</div>
                        </div>
                        <div class="price large-text">{{ activity.marketingNose }}</div>
                    </div>
                </div>

                <DxPopover/>

            </div>
        </div>

        <DxPopup
                :width="660"
                :height="640"
                :drag-enabled="false"
                :title="currentHouse.activityName "
                :visible="popupVisible"
        >
            <marketingMessage :activity="activity"  @closeProp="closeProp" ></marketingMessage>


            <DxToolbarItem widget="dxButton" toolbar="bottom" location="after"  :options="closeButtonOptions"></DxToolbarItem>
        </DxPopup>
    </div>
</template>

<script>
    import DxPopup from 'devextreme-vue/popup';
    import DxPopover from 'devextreme-vue/popover';
    import DxButton from "devextreme-vue/button";
    import '../../../css/my_styles.css';
    import DxTagBox from 'devextreme-vue/tag-box';

    import EnquireBox from "../../../components/enquire-box";
    import marketingMessage from "../../../components/marketing_message";


    export default {
        name: "markeingActivity",
        components: {
            // eslint-disable-next-line vue/no-unused-components
            DxButton, DxPopup, DxPopover,DxTagBox,EnquireBox,marketingMessage
        },
        data() {
            return {
                dataList: [],
                currentHouse:{},
                popupVisible : false,
                closeButtonOptions: {
                    text: 'Close',
                    onClick: () => {
                        this.popupVisible = false;
                    },
                },
                enquireTitle :"",
                message:"",

                activity : {}
            }
        },
        created() {
            ///获取正在营销的活动
           this.getDataSource()
        },
        watch:{

        },
        methods: {
            getDataSource(){
                this.$http.get_marketing_list({"type":"0"}).then(res => {
                    if(res.status == "success"){
                        this.dataList=res.data
                    }

                })
            },
            showHouse: async function (activity){
                this.activity = activity
                this.popupVisible = true
                this.currentHouse = activity
                this.popupVisible = true

            },

            closeProp(){
                this.popupVisible = false
                this.getDataSource()
            }
        }
    }
</script>

<style src="../../../css/activity_styles.css"></style>
<style>
    .form_submit{
        display: flex;
        flex-direction: row;
        justify-content: center;
        /*align-content: center;*/
    }
</style>